// ./src/components/generic/GapSelector/GapSelector.tsx
import React from "react";
import { Select, SelectProps } from "@mantine/core";

const GAP_OPTIONS = [
  {
    value: "0rem",
    label: "None",
    description: "No gap",
  },
  {
    value: "0.5rem",
    label: "Small",
    description: "Small gap (~8px)",
  },
  {
    value: "1rem",
    label: "Normal",
    description: "Normal gap (~16px)",
  },
  {
    value: "1.5rem",
    label: "Large",
    description: "Large gap (~24px)",
  },
] as const;

export interface GapSelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Current gap value */
  value: string | null | undefined;

  /** Callback when gap changes */
  onChange: (value: string | null) => void;

  /** Whether to show descriptions in the dropdown */
  withDescriptions?: boolean;
}

export const GapSelector: React.FC<GapSelectorProps> = ({
  value,
  onChange,
  withDescriptions = false,
  placeholder = "Select gap",
  label,
  description,
  error,
  ...selectProps
}) => {
  // Prepare select data with optional descriptions
  const selectData = GAP_OPTIONS.map((option) => {
    let label: string = option.label;

    if (withDescriptions) {
      label = `${option.label} - ${option.description}`;
    }

    return {
      value: option.value,
      label,
    };
  });

  return (
    <Select
      {...selectProps}
      label={label}
      description={description}
      error={error}
      data={selectData}
      value={value || null}
      onChange={onChange}
      placeholder={placeholder}
      clearable={false}
    />
  );
};

// Export gap options for use in other components
export { GAP_OPTIONS };
